var Sitepackage = Sitepackage || {
  Content: {
    Faq: {},
    News: {}
  },
  Extensions: {},
  Plugins: {
    Members: {}
  }
};

/**
 * Wrapper class for cookie functions.
 *
 * @class
 */
function CookieUtility() {
}


/**
 * Sets a new cookie.
 *
 * @param {string} name Name of the cookie
 * @param {string} data Data of the cookie
 * @param {Date} [expires] When the cookie expires (defaults to null)
 * @param {string} [path] Path of the cookie (defaults to "/")
 * @returns {string} The complete cookie string, already set
 * @static
 */
CookieUtility.set = function (name, data, expires, path) {
  let cookie = name + '=' + data;

  if (expires !== undefined) {
    cookie += ';expires=' + expires.toUTCString();
  }

  if (path !== undefined) {
    cookie += ';path=' + path;
  } else {
    cookie += ';path=/';
  }

  document.cookie = cookie;
  return cookie;
};


/**
 * Gets the content of a cookie.
 *
 * @param {string} name Name of the cookie to get content from
 * @returns {string} Content of the cookie, if available
 * @static
 */
CookieUtility.get = function (name) {
  if (!CookieUtility.exists(name)) {
    return '';
  }

  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const parts = cookies[i].split('=');
    const cookieName = parts[0].trim();
    const cookieValue = parts[1].trim();

    if (cookieName === name) {
      return cookieValue;
    }
  }

  return '';
};


/**
 * Removes a cookie.
 *
 * @param {string} name Name of the cookie to remove
 * @returns {boolean} True when the cookie was removed, otherwise false
 * @static
 */
CookieUtility.remove = function (name) {
  if (!CookieUtility.exists(name)) {
    return false;
  }

  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT';
  return true;
};


/**
 * Checks whether a cookie exists or not.
 *
 * @param {string} name Name of the cookie to check
 * @returns {boolean} True when the cookie exists, otherwise false
 * @static
 */
CookieUtility.exists = function (name) {
  return document.cookie.indexOf(name + '=') >= 0;
};

/**
 * Contains general utilities.
 *
 * @class
 */
function GeneralUtility() {
}

/**
 * Gets the current global language ID.
 *
 * @returns {int} sys_language UID
 * @static
 */
GeneralUtility.getLanguageId = function () {
  if (Globals === undefined || Globals.languageId === undefined || !Globals.languageId) {
    return 0;
  }
  return Globals.languageId;
};

/**
 * Gets the current page UID.
 *
 * @returns {int} Page UID
 * @static
 */
GeneralUtility.getPageUid = function () {
  if (Globals === undefined || Globals.pageUid === undefined || !Globals.pageUid) {
    return 0;
  }
  return Globals.pageUid;
};

/**
 * Gets a language label.
 *
 * @param {string} key Key of the label to get
 * @returns {string} Language label
 * @static
 */
GeneralUtility.getLabel = function (key) {
  if (typeof TYPO3 === 'undefined' || !TYPO3.lang || !TYPO3.lang.hasOwnProperty(key)) {
    return '';
  }
  return TYPO3.lang[key];
};

/**
 * Gets a public asset.
 *
 * @param {string} key Key of the asset to get
 * @returns {string} Asset
 * @static
 */
GeneralUtility.getAsset = function (key) {
  if (Globals === undefined || Globals.assets === undefined || !Globals.assets || !Globals.assets.hasOwnProperty(key)) {
    return '';
  }
  return Globals.assets[key];
};

/**
 * Gets the current page URL without any parameters or hashes.
 *
 * @param {bool} trailingSlash (Optional) null => do nothing, true => add trailing slash, false => remove trailing slash (defaults to 0)
 * @returns {string} Current URL
 * @static
 */
GeneralUtility.getBaseUrl = function (trailingSlash) {
  if (trailingSlash === undefined) {
    trailingSlash = null;
  }

  let href = window.location.href;
  href = href.split('?')[0];
  href = href.split('#')[0];
  let length = href.length;

  if (trailingSlash === true && href.charAt(length - 1) !== '/') {
    href += '/';
  } else if (trailingSlash === false && href.charAt(length - 1) === '/') {
    href = href.substring(0, length - 1);
  }

  return href;
};

/**
 * Adds a class to an selector for a certain amout of time, then removes it
 * again.
 *
 * @param {Element} element Element to add class to
 * @param {string} newClass Class to add
 * @param {int} period (Optional) Live-Time of the class in ms, defaults to 1000ms
 * @returns {void}
 * @static
 */
GeneralUtility.addTimedClass = function (element, newClass, period) {
  if (period === undefined) {
    period = 1000;
  }

  if (!element || !newClass) {
    return;
  }

  element.classList.add(newClass);
  setTimeout(function () {
    element.classList.remove(newClass);
  }, period);
};

/**
 * Checks if the current devices is a touch device. Note that devices with multi-touch capable touchpads like laptops will also be detected as mobile.
 *
 * @returns {boolean} True when the device is touchable, otherwise false
 * @static
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#Mobile_Device_Detection
 */
GeneralUtility.isTouch = function () {
  let hasTouchScreen;

  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    // @ts-ignore
    hasTouchScreen = navigator.msMaxTouchPoints > 0;
  } else {
    const mQ = window.matchMedia !== undefined && window.matchMedia('(pointer:coarse)');
    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      // @ts-ignore
      const UA = navigator.userAgent;
      hasTouchScreen = (
          /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
          /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
      );
    }
  }

  return hasTouchScreen;
};

/**
 * Gets the current device orientation.
 *
 * @returns {string} "portrait" or "landscape"
 * @static
 */
GeneralUtility.getDeviceOrientation = function () {
  if (window.innerHeight > window.innerWidth) {
    return 'portrait';
  } else {
    return 'landscape';
  }
};

/**
 * Contains language utilities.
 *
 * @class
 */
function LanguageUtility() {
}

/**
 * Gets the current global language ID.
 *
 * @returns {int} sys_language UID
 * @static
 */
LanguageUtility.getLanguageId = function () {
  if (Globals === undefined || Globals.languageId === undefined || !Globals.languageId) {
    return 0;
  }
  return Globals.languageId;
};

/**
 * Gets all language labels.
 *
 * @returns {object} Language label
 * @static
 */
LanguageUtility.getLabels = function (key) {
  if (typeof TYPO3 === 'undefined' || !TYPO3.lang) {
    return '';
  }
  return TYPO3.lang;
};

/**
 * Gets a language label.
 *
 * @param {string} key Key of the label to get
 * @returns {string} Language label
 * @static
 */
LanguageUtility.getLabel = function (key) {
  if (typeof TYPO3 === 'undefined' || !TYPO3.lang || !TYPO3.lang.hasOwnProperty(key)) {
    return '';
  }
  return TYPO3.lang[key];
};

/**
 * News content element.
 *
 * @class
 */
Sitepackage.Content.News = (function () {
  /**
   * Initializes the element.
   *
   * @param {JQuery.Element} container Main container of this element
   * @class
   */
  const News = function (container) {
    this.container = container;
    this.initializeDataTable();
  };

  News.prototype.initializeDataTable = function () {
    $('.bsonews.datatable').DataTable({
      layout: {
        topStart: {
          pageLength: {
            menu: [10, 25, 50, 100]
          }
        },
        topEnd: 'search',
        bottomStart: 'info',
        bottomEnd: 'paging'
      },
      order: [0, 'desc'],
      language: {
        emptyTable: LanguageUtility.getLabel('datatables.emptyTable'),
        info: LanguageUtility.getLabel('datatables.info'),
        infoEmpty: LanguageUtility.getLabel('datatables.infoEmpty'),
        infoFiltered: LanguageUtility.getLabel('datatables.infoFiltered'),
        thousands: LanguageUtility.getLabel('datatables.thousands'),
        lengthMenu: LanguageUtility.getLabel('datatables.lengthMenu'),
        loadingRecords: LanguageUtility.getLabel('loading'),
        processing: LanguageUtility.getLabel('pleaseWait'),
        search: LanguageUtility.getLabel('search'),
        zeroRecords: LanguageUtility.getLabel('noResultsFound'),
        paginate: {
          first: LanguageUtility.getLabel('first'),
          previous: LanguageUtility.getLabel('previous'),
          next: LanguageUtility.getLabel('next'),
          last: LanguageUtility.getLabel('last')
        },
        aria: {
          sortAscending: ': ' + LanguageUtility.getLabel('sortAscending'),
          sortDescending: ': ' + LanguageUtility.getLabel('sortDescending')
        }
      }
    });
  };

  return News;
})();

/**
 * Members plugin.
 *
 * @class
 */
Sitepackage.Plugins.Members = (function () {
  /**
   * Initializes the element.
   *
   * @param {JQuery.Element} container Main container of this element
   * @class
   */
  const Members = function (container) {
    this.container = container;
    this.gridContainer = this.container.find('.members-list');
    this.items = this.gridContainer.find('.item');
    this.grid = this.gridContainer.isotope({
      itemSelector: '.item',
      layoutMode: 'fitRows'
    });

    this.items.click(e => {
      this.hideDetailsBox();
      this.openDetailsBox($(e.currentTarget));
      return false;
    });

    $('#members-details a.close').click(() => {
      this.hideDetailsBox();
      return false;
    });

    $('.bsomembers .filter a').click(e => {
      const element = $(e.currentTarget);
      this.hideDetailsBox();

      $('.bsomembers .filter a').removeClass('active');
      element.addClass('active');

      console.log(element);

      let filter = '.category-' + element.data('category');
      if (element.data('category') === 'all') {
        filter = '*';
      }

      this.grid.isotope({filter: filter});
      return false;
    });

    this.redraw();
    $(window).resize(() => {
      this.redraw();
    });
  };

  Members.prototype.redraw = function () {
    // Equal height
    let tallest = 0;
    const inner = $('.members-list .item .inner');
    inner.each((key, element) => {
      element = $(element);
      if (element.height() > tallest) {
        tallest = element.height();
      }
    });
    inner.height(tallest);

    setTimeout(() => {
      this.grid = $('.members-list').isotope({
        itemSelector: '.item',
        layoutMode: 'fitRows'
      });
    }, 250);
  };

  Members.prototype.openDetailsBox = function (item) {
    $('.members-list .item').removeClass('active');
    item.addClass('active');
    if ($('#members-details').is(':visible')) {
      $('#members-details .details-content').fadeOut('normal', () => {
        const content = $('#members-details .details-content');
        content.html(item.find('.details').html());
        content.fadeIn('normal');
      });
    } else {
      $('#members-details .details-content').html(item.find('.details').html());
      $('#members-details').fadeIn('normal');
    }
    $('body').addClass('overlay-open');
  };

  Members.prototype.hideDetailsBox = function () {
    $('.members-list .item').removeClass('active');
    $('#members-details').fadeOut('normal', () => {
      $('#members-details .details-content').html('');
      $('body').removeClass('overlay-open');
    });
  };

  return Members;
})();

/**
 * Solr extension.
 *
 * @class
 */
Sitepackage.Extensions.Solr = (function () {
  /**
   * Initializes the extension.
   *
   * @class
   */
  const Solr = function () {
    this.initializeSuggestController();
    $('body').on('tx_solr_updated', () => {
      this.initializeSuggestController();
    });
  }

  /**
   * Copied from EXT:solr/Resources/Public/JavaScript/suggest_controller.js and
   * adjusted slightly.
   *
   * @returns {void}
   */
  Solr.prototype.initializeSuggestController = function () {
    jQuery('form[data-suggest]').each(function () {
      var $form = $(this), $searchBox = $form.find('.tx-solr-suggest'), $formAutoComplete;

      if ($form.find('.tx-solr-autocomplete').length > 0) {
        $formAutoComplete = $form.find('.tx-solr-autocomplete');
      } else {
        $formAutoComplete = $('body');
      }

      // when no specific container found, use the form as container
      if ($searchBox.length === 0) {
        $searchBox = $form;
      }
      $searchBox.css('position', 'relative');

      // Disable autofocus of search form, so that links with anchor hashes in them are not overruled.
      // $form.find('.tx-solr-suggest-focus').focus();

      // Prevent submit of empty search form
      $form.on('submit', function (e) {
        if ($form.find('.tx-solr-suggest-focus').val() === '') {
          e.preventDefault();
          $form.find('.tx-solr-suggest-focus').focus();
        }
      });

      $form.find('.tx-solr-suggest').devbridgeAutocomplete({
        serviceUrl: $form.data('suggest'),
        dataType: 'json',
        paramName: 'tx_solr[queryString]',
        groupBy: 'category',
        maxHeight: 1000,
        appendTo: $formAutoComplete,
        autoSelectFirst: false,
        triggerSelectOnValidInput: false,
        width: $searchBox.outerWidth() * 0.66,
        onSelect: function (suggestion) {
          // go to link when selecting found result
          if (suggestion.data.link) {
            // Open youtube in overlay
            if (suggestion.data.link.indexOf('https://www.youtube.com') === 0) {
              openVideoOverlay(suggestion.data.link);
            } else {
              location.href = suggestion.data.link;
            }
            // else trigger form submit (do search)
          } else {
            $form.trigger('submit');
          }
        },
        transformResult: function (response) {
          if (!response.suggestions) return {suggestions: []};
          var firstSuggestion, result = {
            suggestions: $.map(response.suggestions, function (count, suggestion) {
              if (!firstSuggestion) firstSuggestion = suggestion;
              return {value: suggestion, data: {category: 'suggestion', count: count}};
            })
          };

          $.each(response.documents, function (key, value) {
            var dataObject = value;

            var defaultGroup = $form.data('suggest-header') ? $form.data('suggest-header') : 'Top results';
            dataObject.category = defaultGroup;

            // if a group is set we try to get a label
            if (dataObject.group) {
              dataObject.category = $form.data('suggest-header-' + dataObject.group) ? $form.data('suggest-header-' + dataObject.group) : dataObject.group;
            }

            result.suggestions.push(
              {
                value: firstSuggestion,
                data: dataObject
              }
            );
          });
          return result;
        },
        beforeRender: function (container) {
          // remove first group header
          container.find('.autocomplete-group:first').html($form.data('suggestions-header') ? $form.data('suggestions-header') : 'Suchvorschläge');
          container.addClass('tx-solr-autosuggest');

          // add active class to container
          $searchBox.parent().addClass('autocomplete-active').fadeIn();
        },
        formatResult: function (suggestion, currentValue) {
          // Do not replace anything if the current value is empty
          if (!currentValue) {
            return suggestion.value;
          }
          var pattern = '(' + $.Autocomplete.utils.escapeRegExChars(currentValue.trim()) + ')';
          // normal suggestion
          if (suggestion.data.category === 'suggestion') {
            return suggestion.value
            .replace(new RegExp(pattern, 'gi'), '<span>$1<\/span>')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/&lt;(\/?span)&gt;/g, '<$1>');

            // results
          } else {
            var title = suggestion.data.title
            .replace(new RegExp(pattern, 'gi'), '<span>$1<\/span>')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/&lt;(\/?span)&gt;/g, '<$1>');

            return '<div class="' + suggestion.data.type + '">' +
              (suggestion.data.previewImage ? '<figure ' + (suggestion.data.hasVideo ? 'class="hasVideo"' : '') + '><img src="' + suggestion.data.previewImage + '" /></figure>' : '') +
              '<a href="' + suggestion.data.link + '" class="internal-link">' + title + '</a>' +
              '</div>';
          }
        },
        formatGroup:  function (suggestion, category) {
          return '<h2 class="autocomplete-group">' + category + "</h2>";
        },
      }).on('blur', function () {
        $searchBox.parent().removeClass('autocomplete-active');
        var $box = $(this);
        setTimeout(function () {
          $box.devbridgeAutocomplete('hide');
        }, 200);
      });
    });
  };

  return Solr;
})();


/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   Supplemental JS for the disclosure menu keyboard behavior
 */

'use strict';

class DisclosureNav {
  constructor(domNode) {
    this.rootNode = domNode;
    this.controlledNodes = [];
    this.openIndex = null;
    this.useArrowKeys = true;
    /** EB MODIFICATIONS: for mouseOver */
    this.keepSubNavOpen = false;
    /** EB MODIFICATIONS: .disclosure-nav added */
    this.topLevelNodes = [
      ...this.rootNode.querySelectorAll(
        '.main-link, .disclosure-nav button[aria-expanded][aria-controls]'
      ),
    ];
    this.topLevelNodes.forEach((node) => {
      // handle button + menu
      if (
        node.tagName.toLowerCase() === 'button' &&
        node.hasAttribute('aria-controls')
      ) {
        /** EB MODIFICATIONS: querySelector 'ul' > '[data-eb-submenuwrapper="true"]' */
        const menu = node.parentNode.querySelector('[data-eb-submenuwrapper="true"]');
        if (menu) {
          // save ref controlled menu
          this.controlledNodes.push(menu);

          // collapse menus
          node.setAttribute('aria-expanded', 'false');
          this.toggleMenu(menu, false);

          // attach event listeners
          menu.addEventListener('keydown', this.onMenuKeyDown.bind(this));
          node.addEventListener('click', this.onButtonClick.bind(this));
          node.addEventListener('keydown', this.onButtonKeyDown.bind(this));
          /** EB MODIFICATIONS: add hover (project specific - no hover is better) */
          node.previousSibling.addEventListener('mouseover', this.onMouseOver.bind(this));
          node.parentNode.addEventListener('mouseleave', this.onMouseLeave.bind(this));
          /** EB MODIFICATIONS end */
        }
      }
      // handle links
      else {
        this.controlledNodes.push(null);
        node.addEventListener('keydown', this.onLinkKeyDown.bind(this));
      }
    });

    this.rootNode.addEventListener('focusout', this.onBlur.bind(this));
  }

  controlFocusByKey(keyboardEvent, nodeList, currentIndex) {
    switch (keyboardEvent.key) {
      case 'ArrowUp':
      case 'ArrowLeft':
        keyboardEvent.preventDefault();
        if (currentIndex > -1) {
          var prevIndex = Math.max(0, currentIndex - 1);
          nodeList[prevIndex].focus();
        }
        break;
      case 'ArrowDown':
      case 'ArrowRight':
        keyboardEvent.preventDefault();
        if (currentIndex > -1) {
          var nextIndex = Math.min(nodeList.length - 1, currentIndex + 1);
          nodeList[nextIndex].focus();
        }
        break;
      case 'Home':
        keyboardEvent.preventDefault();
        nodeList[0].focus();
        break;
      case 'End':
        keyboardEvent.preventDefault();
        nodeList[nodeList.length - 1].focus();
        break;
    }
  }

  // public function to close open menu
  close() {
    this.toggleExpand(this.openIndex, false);
  }

  onBlur(event) {
    var menuContainsFocus = this.rootNode.contains(event.relatedTarget);
    if (!menuContainsFocus && this.openIndex !== null) {
      this.toggleExpand(this.openIndex, false);
    }
  }

  onButtonClick(event) {
    var button = event.target;
    var buttonIndex = this.topLevelNodes.indexOf(button);
    var buttonExpanded = button.getAttribute('aria-expanded') === 'true';
    /** EB MODIFICATIONS: for mouseover */
    this.keepSubNavOpen = !buttonExpanded;
    /** EB MODIFICATIONS end */
    this.toggleExpand(buttonIndex, !buttonExpanded);
  }

  /** EB MODIFICATIONS: add mouseover */
  onMouseOver(event) {
    // The dropdown does not open through hover over the button – on purpose. Click-Hover issues.
    // If the dropdown is already open (through click), hover over the link keeps it open.
    // If the dropdown is opened on hover, click on the button will close the dropdown as the button
    // is toggled to match hover and click status.
    var button = event.target.parentNode.querySelector('button');
    if(button.getAttribute('aria-expanded') === 'false') {
    // Reset keepOpen variable if sibling is not expanded.
      this.keepSubNavOpen = false;
    }

    setTimeout(() => {
      var buttonIndex = this.topLevelNodes.indexOf(button);
      this.toggleExpand(buttonIndex, true);
    }, 200);
  }

  onMouseLeave(event) {
    if(!this.keepSubNavOpen) {
      setTimeout(() => {
        this.toggleExpand(this.openIndex, false);
      }, 200);
    }
  }
  /** EB MODIFICATIONS end  */

  onButtonKeyDown(event) {
    var targetButtonIndex = this.topLevelNodes.indexOf(document.activeElement);

    // close on escape
    if (event.key === 'Escape') {
      this.toggleExpand(this.openIndex, false);
    }

    // move focus into the open menu if the current menu is open
    else if (
      this.useArrowKeys &&
      this.openIndex === targetButtonIndex &&
      event.key === 'ArrowDown'
    ) {
      event.preventDefault();
      this.controlledNodes[this.openIndex].querySelector('a').focus();
    }

    // handle arrow key navigation between top-level buttons, if set
    else if (this.useArrowKeys) {
      this.controlFocusByKey(event, this.topLevelNodes, targetButtonIndex);
    }
  }

  onLinkKeyDown(event) {
    var targetLinkIndex = this.topLevelNodes.indexOf(document.activeElement);

    // handle arrow key navigation between top-level buttons, if set
    if (this.useArrowKeys) {
      this.controlFocusByKey(event, this.topLevelNodes, targetLinkIndex);
    }
  }

  onMenuKeyDown(event) {
    if (this.openIndex === null) {
      return;
    }

    var menuLinks = Array.prototype.slice.call(
      this.controlledNodes[this.openIndex].querySelectorAll('a')
    );
    var currentIndex = menuLinks.indexOf(document.activeElement);

    // close on escape
    if (event.key === 'Escape') {
      this.topLevelNodes[this.openIndex].focus();
      this.toggleExpand(this.openIndex, false);
    }

    // handle arrow key navigation within menu links, if set
    else if (this.useArrowKeys) {
      this.controlFocusByKey(event, menuLinks, currentIndex);
    }
  }

  toggleExpand(index, expanded) {
    // close open menu, if applicable
    if (this.openIndex !== index) {
      this.toggleExpand(this.openIndex, false);
    }

    // handle menu at called index
    if (this.topLevelNodes[index]) {
      this.openIndex = expanded ? index : null;
      this.topLevelNodes[index].setAttribute('aria-expanded', expanded);
      this.toggleMenu(this.controlledNodes[index], expanded);
    }
  }

  toggleMenu(domNode, show) {
    if (domNode) {
      /**
       * EB MODIFICATIONS START
       * Use classes (+ media queries in css) instead of style display.
       * Check if dropdown ends outside of viewport (left/right)
       */
      if (show) {
        var offsetLeft = domNode.getBoundingClientRect().x;
        var width = domNode.offsetWidth;

        if ((offsetLeft + width) > (window.innerWidth - 10)) {
          domNode.classList.add('sub-nav-align-right');
          domNode.classList.remove('sub-nav-align-left');
        }
        if (offsetLeft < 0) {
          domNode.classList.add('sub-nav-align-left');
          domNode.classList.remove('sub-nav-align-right');
        }
        domNode.classList.add('show');
      } else {
        domNode.classList.remove('show');
        domNode.classList.remove('sub-nav-align-right');
        domNode.classList.remove('sub-nav-align-left');
      }
      /** EB MODIFICATIONS END */
    }
  }

  updateKeyControls(useArrowKeys) {
    this.useArrowKeys = useArrowKeys;
  }
}

/* Initialize Disclosure Menus */

window.addEventListener(
  'load',
  function () {
    /**
     * EB MODIFICATIONS START
     * Load as <a> and replace with <button> if javascript can be loaded.
     */
    var linksToButtons = document.querySelectorAll(".nav-link-button");
    for (var j = 0; j < linksToButtons.length; j++) {
      // Change <a> with subpages to <button>
      var original = linksToButtons[j];
      var replacement = document.createElement('button');
      for(var i = 0, l = original.attributes.length; i < l; ++i){
        var nodeName  = original.attributes.item(i).nodeName;
        var nodeValue = original.attributes.item(i).nodeValue;
        replacement.setAttribute(nodeName, nodeValue);
      }
      replacement.innerHTML = original.innerHTML;
      original.parentNode.replaceChild(replacement, original);

      // Add attributes to button
      replacement.setAttribute('aria-controls', replacement.nextSibling.id);
      replacement.setAttribute('aria-expanded', 'false');
      replacement.setAttribute('type', 'button');
      replacement.removeAttribute('href');
    }
    /** EB MODIFICATIONS END */

    var menus = document.querySelectorAll('.disclosure-nav');
    var disclosureMenus = [];

    for (var i = 0; i < menus.length; i++) {
      disclosureMenus[i] = new DisclosureNav(menus[i]);
    }

    // listen to arrow key checkbox
    var arrowKeySwitch = document.getElementById('arrow-behavior-switch');
    if (arrowKeySwitch) {
      arrowKeySwitch.addEventListener('change', function () {
        var checked = arrowKeySwitch.checked;
        for (var i = 0; i < disclosureMenus.length; i++) {
          disclosureMenus[i].updateKeyControls(checked);
        }
      });
    }

    // fake link behavior
    disclosureMenus.forEach((disclosureNav, i) => {
      var links = menus[i].querySelectorAll('[href="#mythical-page-content"]');
      var examplePageHeading = document.getElementById('mythical-page-heading');
      for (var k = 0; k < links.length; k++) {
        // The codepen export script updates the internal link href with a full URL
        // we're just manually fixing that behavior here
        links[k].href = '#mythical-page-content';

        links[k].addEventListener('click', (event) => {
          // change the heading text to fake a page change
          var pageTitle = event.target.innerText;
          examplePageHeading.innerText = pageTitle;

          // handle aria-current
          for (var n = 0; n < links.length; n++) {
            links[n].removeAttribute('aria-current');
          }
          event.target.setAttribute('aria-current', 'page');
        });
      }
    });
  },
  false
);

/**
 * Main entry point for the app.
 *
 * @class
 */
function App() {
  this.html = $('html');
  this.body = $('body');
  this.content = $('.content');

  this.fixViewHeight();
  this.initializeTouch();
  this.initializeGeneral();
  this.initializeLightbox();
  this.initializeAriaCarousel();
  this.initializeContent();
  this.initializePlugins();
  this.initializeExtensions();
}

/**
 * Fixes a bug where mobile devices like iPad calculate viewheight-property wrongly.
 *
 * @returns {void}
 */
App.prototype.fixViewHeight = function () {
  var vh = window.innerHeight * 0.01;
  this.html.css('--vh', vh + 'px');
};

/**
 * Initialize touch functionality.
 *
 * @returns {void}
 */
App.prototype.initializeTouch = function () {
  if (GeneralUtility.isTouch()) {
    document.body.classList.add('is-touch');
    document.body.classList.remove('no-touch');
  } else {
    document.body.classList.add('no-touch');
    document.body.classList.remove('is-touch');
  }
};

/**
 * Initializes general components.
 *
 * @returns {void}
 */
App.prototype.initializeGeneral = function () {
  $.fn.placeholder ? $('input, textarea').placeholder() : null;

  // Footer Copyright
  $('#current-year').html(new Date().getFullYear());

  // Search field focus
  $('#topics_search').focus(e => {
    const element = $(e.target);
    if (element.value === element.defaultValue) {
      element.value = '';
      $(this).removeClass('blur').addClass('focus');
    }
  }).blur(e => {
    const element = $(e.target);
    if (element.value === '') {
      element.value = element.defaultValue;
      element.removeClass('focus').addClass('blur');
    }
  }).blur();

  // Adjust gallery size for YouTube preview images
  $('a.youtube-embed').each((key, element) => {
    $(element).closest('figure').css('width', '100%').css('float', 'none');
    $(element).closest('.ce-column').css('width', '100%').css('float', 'none');
    $(element).closest('.ce-gallery').css('width', '100%').css('float', 'none');
  });

  $('[data-ctype="sitepackage_container_11"]').each((key, container) => {
    const row = $(container).children('.row');
    if (!row.children('div:eq(0)').find('.content-panel').hasClass('teaser')) {
      row.children('div:eq(0)').find('.content-panel').each((key, panel) => {
        panel = $(panel);
        const boxHeight = panel.innerHeight();
        const otherBox = row.children('div:eq(1)').find('.content-panel:eq(' + key + ')');
        const otherBoxHeight = otherBox.innerHeight();

        if (otherBox.length > 0) {
          if (otherBoxHeight > boxHeight) {
            panel.css({'height': otherBoxHeight});
            otherBox.css({'height': otherBoxHeight});
          } else {
            panel.css({'height': boxHeight});
            otherBox.css({'height': boxHeight});
          }
        }
      });
    }
  });

  if ($('.start-panel.events.short.api').length) {
    $('.start-panel.events.short.api .items').load('/?type=6014', () => {
      $('#loading-animation').hide();
      $('.start-panel.events.short.api .items').fadeIn();
    });
  }

  if (screen.width <= 767) {
    if (this.content.length > 0) {
      $('html,body').animate({scrollTop: this.content.offset().top}, 'slow');
    }
  }
};

/**
 * Initializes the lightbox.
 *
 * @returns {void}
 */
App.prototype.initializeLightbox = function () {
  var lightbox = new GLightbox({
    selector: '*[data-lightbox]'
  });
  let galleryItems = document.querySelectorAll('[data-lightbox]');
  let clickedLightboxLink;
  galleryItems.forEach(function (item) {
    item.addEventListener('click', function (event) {
        clickedLightboxLink = (event.target.nodeName === "a") ? event.target : event.target.closest('a[data-lightbox]');
    });
  })
  lightbox.on('open', () => {
    if (document.documentElement.lang === "de") {
      var closeBtn = document.querySelector('.gclose');
      closeBtn?.setAttribute('aria-label', 'schließen');
      var nextBtn = document.querySelector('.gnext');
      nextBtn?.setAttribute('aria-label', 'weiter');
      var prevBtn = document.querySelector('.gnprev');
      prevBtn?.setAttribute('aria-label', 'zurück');
    }
  });
  lightbox.on('close',function () {
    clickedLightboxLink.focus();
  });
};

/**
 * Initializes content elements.
 *
 * @returns {void}
 */
App.prototype.initializeContent = function () {
  $('[data-ctype="sitepackage_news"]').each((key, container) => {
    new Sitepackage.Content.News($(container));
  });
};

/**
 * Initializes plugins.
 *
 * @returns {void}
 */
App.prototype.initializePlugins = function () {
  $('[data-ctype="sitepackage_members"]').each((key, container) => {
    new Sitepackage.Plugins.Members($(container));
  });
};

/**
 * Initializes extensions.
 *
 * @returns {void}
 */
App.prototype.initializeExtensions = function () {
  new Sitepackage.Extensions.Solr();
};

// Run on DOM ready
$(document).ready(function () {
  new App();
});

/**
 * W3 Aria Carousel
 *
 * Source: https://www.w3.org/WAI/ARIA/apg/patterns/carousel/examples/carousel-2-tablist/
 * Adjusted to project
 *
 * The more accessible mode was not tested or adjusted.
 */
App.prototype.initializeAriaCarousel = function () {

  let CarouselTablist = function (node, options) {
    // merge passed options with defaults
    options = Object.assign(
        {
          accessibleCaptions: true,
          autoplay: false,
          moreaccessible: false,
          norotate: false,
          paused: false,
          playButton: true
        },
        options || {}
    );

    // a prefers-reduced-motion user setting must always override autoplay
    let hasReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (hasReducedMotion.matches) {
      options.paused = true;
    }

    /* DOM properties */
    this.isOnLoad = true;
    this.domNode = node;

    this.tablistNode = node.querySelector('[role=tablist]');
    this.containerNode = node.querySelector('.carousel-items');

    this.tabNodes = [];
    this.tabpanelNodes = [];

    this.liveRegionNode = node.querySelector('.carousel-items');
    this.pausePlayButtonNode = this.domNode.querySelector('.controls button.playPause');

    this.previousButtonNode = this.domNode.querySelector('.carousel-inner button.previous');
    this.nextButtonNode = this.domNode.querySelector('.carousel-inner button.next');

    this.playLabel = 'Starte automatisches Abspielen';
    this.pauseLabel = 'Pausiere automatisches Abspielen';

    /* State properties */
    this.hasUserActivatedPlay = false; // set when the user activates the play/pause button
    this.isAutoRotationDisabled = options.norotate; // This property for disabling auto rotation
    this.isPlayingEnabled = !options.paused; // This property is also set in updatePlaying method
    this.timeInterval = 7000; // length of slide rotation in ms
    this.currentIndex = 0; // index of current slide
    this.slideTimeout = null; // save reference to setTimeout

    // initialize tabs
    this.tablistNode.addEventListener('focusin', this.handleTabFocus.bind(this));
    this.tablistNode.addEventListener('focusout', this.handleTabBlur.bind(this));

    let nodes = node.querySelectorAll('[role="tab"]');

    for (let i = 0; i < nodes.length; i++) {
      let n = nodes[i];

      this.tabNodes.push(n);

      n.addEventListener('keydown', this.handleTabKeydown.bind(this));
      n.addEventListener('click', this.handleTabClick.bind(this));

      // initialize tabpanels

      let tabpanelNode = document.getElementById(n.getAttribute('aria-controls'));

      if (tabpanelNode) {
        this.tabpanelNodes.push(tabpanelNode);

        // support stopping rotation when any element receives focus in the tabpanel
        tabpanelNode.addEventListener(
            'focusin',
            this.handleTabpanelFocusIn.bind(this)
        );
        tabpanelNode.addEventListener(
            'focusout',
            this.handleTabpanelFocusOut.bind(this)
        );

        let imageLink = tabpanelNode.querySelector('.carousel-image a');

        if (imageLink) {
          imageLink.addEventListener(
              'focus',
              this.handleImageLinkFocus.bind(this)
          );
          imageLink.addEventListener('blur', this.handleImageLinkBlur.bind(this));
        }
      } else {
        this.tabpanelNodes.push(null);
      }
    }

    // Pause Button
    if (this.pausePlayButtonNode) {
      this.pausePlayButtonNode.addEventListener(
          'click',
          this.handlePausePlayButtonClick.bind(this)
      );
    }

    // Previous Button
    if (this.previousButtonNode) {
      this.previousButtonNode.addEventListener('click', () => this.setSelectedToPreviousTab(false));
    }

    // Next Button
    if (this.nextButtonNode) {
      this.nextButtonNode.addEventListener('click', () => this.setSelectedToNextTab(false));
    }

    // Handle hover events
    this.domNode.addEventListener('mouseover', this.handleMouseOver.bind(this));
    this.domNode.addEventListener('mouseout', this.handleMouseOut.bind(this));

    // initialize behavior based on options

    this.enableOrDisableAutoRotation(options.norotate);
    this.updatePlaying(!options.paused && !options.norotate);
    this.setAccessibleStyling(options.moreaccessible);
    this.rotateSlides();
  };

  /* Public function to disable/enable rotation and if false, hide pause/play button*/
  CarouselTablist.prototype.enableOrDisableAutoRotation = function (disable) {
    this.isAutoRotationDisabled = disable;
    this.pausePlayButtonNode.hidden = disable;
  };

  /* Public function to update controls/caption styling */
  CarouselTablist.prototype.setAccessibleStyling = function (accessible) {
    if (accessible) {
      this.domNode.classList.add('carousel-tablist-moreaccessible');
    } else {
      this.domNode.classList.remove('carousel-tablist-moreaccessible');
    }
  };

  CarouselTablist.prototype.hideTabpanel = function (index) {
    let tabNode = this.tabNodes[index];
    let panelNode = this.tabpanelNodes[index];

    tabNode.setAttribute('aria-selected', 'false');
    tabNode.setAttribute('tabindex', '-1');

    if (panelNode) {
      panelNode.classList.remove('active');
    }
  };

  CarouselTablist.prototype.showTabpanel = function (index, moveFocus) {
    let tabNode = this.tabNodes[index];
    let panelNode = this.tabpanelNodes[index];

    tabNode.setAttribute('aria-selected', 'true');
    tabNode.removeAttribute('tabindex');

    if (panelNode) {
      panelNode.classList.add('active');
    }

    if (moveFocus) {
      tabNode.focus();
    }
  };

  CarouselTablist.prototype.setSelectedTab = function (index, moveFocus) {
    if (index === this.currentIndex) {
      return;
    }
    this.currentIndex = index;

    for (let i = 0; i < this.tabNodes.length; i++) {
      this.hideTabpanel(i);
    }

    this.showTabpanel(index, moveFocus);
  };

  CarouselTablist.prototype.setSelectedToPreviousTab = function (moveFocus) {
    let nextIndex = this.currentIndex - 1;

    if (nextIndex < 0) {
      nextIndex = this.tabNodes.length - 1;
    }

    this.setSelectedTab(nextIndex, moveFocus);
  };

  CarouselTablist.prototype.setSelectedToNextTab = function (moveFocus) {
    let nextIndex = this.currentIndex + 1;

    if (nextIndex >= this.tabNodes.length) {
      nextIndex = 0;
    }

    this.setSelectedTab(nextIndex, moveFocus);
  };

  CarouselTablist.prototype.rotateSlides = function () {
    if (!this.isAutoRotationDisabled) {
      if (
          (!this.hasFocus && !this.hasHover && this.isPlayingEnabled) ||
          this.hasUserActivatedPlay
      ) {
        if (!this.isOnLoad) {
          this.setSelectedToNextTab(false);
        }
        this.isOnLoad = false;
      }
    }

    this.slideTimeout = setTimeout(
        this.rotateSlides.bind(this),
        this.timeInterval
    );
  };

  CarouselTablist.prototype.updatePlaying = function (play) {
    this.isPlayingEnabled = play;

    if (play) {
      this.pausePlayButtonNode.setAttribute('aria-label', this.pauseLabel);
      this.pausePlayButtonNode.classList.remove('play');
      this.pausePlayButtonNode.classList.add('pause');
      this.liveRegionNode.setAttribute('aria-live', 'off');
    } else {
      this.pausePlayButtonNode.setAttribute('aria-label', this.playLabel);
      this.pausePlayButtonNode.classList.remove('pause');
      this.pausePlayButtonNode.classList.add('play');
      this.liveRegionNode.setAttribute('aria-live', 'polite');
    }
  };

  /* Event Handlers */

  CarouselTablist.prototype.handleImageLinkFocus = function () {
    this.liveRegionNode.classList.add('focus');
  };

  CarouselTablist.prototype.handleImageLinkBlur = function () {
    this.liveRegionNode.classList.remove('focus');
  };

  CarouselTablist.prototype.handleMouseOver = function (event) {
    if (!this.pausePlayButtonNode.contains(event.target)) {
      this.hasHover = true;
    }
  };

  CarouselTablist.prototype.handleMouseOut = function () {
    this.hasHover = false;
  };

  /* EVENT HANDLERS */

  CarouselTablist.prototype.handlePausePlayButtonClick = function () {
    this.hasUserActivatedPlay = !this.isPlayingEnabled;
    this.updatePlaying(!this.isPlayingEnabled);
  };

  /* Event Handlers for Tabs*/

  CarouselTablist.prototype.handleTabKeydown = function (event) {
    let flag = false;

    switch (event.key) {
      case 'ArrowRight':
        this.setSelectedToNextTab(true);
        flag = true;
        break;

      case 'ArrowLeft':
        this.setSelectedToPreviousTab(true);
        flag = true;
        break;

      case 'Home':
        this.setSelectedTab(0, true);
        flag = true;
        break;

      case 'End':
        this.setSelectedTab(this.tabNodes.length - 1, true);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  };

  CarouselTablist.prototype.handleTabClick = function (event) {
    let index = this.tabNodes.indexOf(event.currentTarget);
    this.setSelectedTab(index, true);
  };

  CarouselTablist.prototype.handleTabFocus = function () {
    this.tablistNode.classList.add('focus');
    this.liveRegionNode.setAttribute('aria-live', 'polite');
    this.hasFocus = true;
  };

  CarouselTablist.prototype.handleTabBlur = function () {
    this.tablistNode.classList.remove('focus');
    if (this.playState) {
      this.liveRegionNode.setAttribute('aria-live', 'off');
    }

    this.hasFocus = false;
  };

  /* Event Handlers for Tabpanels*/

  CarouselTablist.prototype.handleTabpanelFocusIn = function () {
    this.hasFocus = true;
  };

  CarouselTablist.prototype.handleTabpanelFocusOut = function () {
    this.hasFocus = false;
  };

  /* Initialize Carousel Tablists and options */
  let carouselEls = document.querySelectorAll('.carousel-tablist');
  let carousels = [];
  let carouselOptions = {};

  carouselEls.forEach(function (node) {
    carousels.push(new CarouselTablist(node, carouselOptions));
  });
};
